import { Alert } from '@ps/isp-web-component-library';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { TXTWCL_To_place_your_betX_please_chan_ELL } from './UpdateCurrency.messages.json';

const UpdateCurrency: React.FC = () => {
  const isCurrencyRestricted = useSelector(select.betSlip.isCurrencyRestricted);
  const requiredPlacementCurrency = useSelector(select.betSlip.requiredPlacementCurrency);

  return isCurrencyRestricted ? (
    <Alert level="update" variant="aggressive" isSquare>
      <Translation
        {...TXTWCL_To_place_your_betX_please_chan_ELL}
        values={{
          0: requiredPlacementCurrency
        }}
      />
    </Alert>
  ) : null;
};

export default UpdateCurrency;
